import { Table } from '@dreryk/react-components';

import { useStatisticsListColumns, useStatisticsListDataConfiguration } from './StatisticsListTable.hooks';
import { StatisticsListType } from './StatisticsListTable.types';

export const StatisticsListTable = (): JSX.Element => (
   <Table<StatisticsListType>
      keyExtractor={'code'}
      columns={useStatisticsListColumns()}
      pageSize={12}
      dataConfiguration={useStatisticsListDataConfiguration()}
      testId={'statisticsListTable'}
   />
);
